module.exports = __webpack_public_path__ + "static/media/suscription-top-section-bg.c4a7ccbb.png";